import { render, staticRenderFns } from "./AccountLink.vue?vue&type=template&id=479369b9&"
import script from "./AccountLink.vue?vue&type=script&lang=js&"
export * from "./AccountLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports